import React, { useState } from 'react';
import EmailCaptureForm from '@sls-react/components/Lockers/EmailCaptureForm';
import { useSession } from '@sls-react/contexts/SessionContext';
import { useCookie } from 'react-use';
import { KnownCookie } from '@sls-react/typings/cookies';

interface Props {}

const FooterEmailCapture: React.FC<Props> = () => {
  const { loggedIn } = useSession();
  const [cookieCaptured] = useCookie('email_captured' as KnownCookie);
  const [captured, setCaptured] = useState(false);

  if (loggedIn || cookieCaptured === '1') {
    return null;
  }

  return (
    <div className="items-center justify-center md:space-x-4 md:flex">
      {captured ? (
        <div className="w-full text-lg font-semibold text-center text-primary-500">
          Thanks
        </div>
      ) : (
        <>
          <div className="mb-4 text-lg font-semibold text-center md:text-left">
            Get the best deals in your inbox
          </div>
          <EmailCaptureForm
            onSuccessfulSubmit={() => setCaptured(true)}
            src="footer"
          />
        </>
      )}
    </div>
  );
};

export default FooterEmailCapture;
